module.exports = __webpack_public_path__ + "static/water_glacier2-8cfd36a70216e1a3dc1047cf5f2748f2.jpg";